import React from "react"

interface Props {
  type?: 'warning'
}

const Note: React.FC<Props> = (props) => {
  let background
  let padding
  let color
  let borderRadius

  if (props.type === 'warning') {
    background = '#ffce00'
    padding = 16
    color = '#000'
    borderRadius = 8
  }

  return (
    <div color="dark" style={{
      marginTop: '30px',
      marginBottom: '30px',
      textAlign: 'center',
      background,
      padding,
      color,
      borderRadius,
    }}>
      {props.children}
    </div>
  )
}

export default Note
